module.exports = __webpack_public_path__ + "img/img2.bc92714b.png";